const PUBLIC_PATHS = new Set([
  "/",
  "/pricing",
  "/faq",
  "/blog",
  "/schools",
  "/hr",
  "/agencies",
  "/construction",
  "/business",
  "/coaches",
  "/privacy",
  "/terms",
  "/contact",
  "/schedule-a-call",
  "/lead-form",
  "/lead-form-confirmation",
  "/staff-care-kit",
  "/staff-care-kit/thank-you",
  "/sms-consent",
  "/auth",
  "/signup",
  "/verify-email",
  "/verify-email-change",
  "/checkout-success",
]);

/** Whether a pathname belongs to the public website rather than the signed-in app. */
export const isPublicPath = (path: string): boolean => {
  const pathname = path.split(/[?#]/, 1)[0];
  return (
    PUBLIC_PATHS.has(pathname) ||
    pathname.startsWith("/reset-password/") ||
    pathname.startsWith("/blog/")
  );
};

/** The homepage renders the signed-in dashboard when a session exists. */
export const isPublicRoute = (path: string, isAuthenticated: boolean): boolean => {
  const pathname = path.split(/[?#]/, 1)[0];
  return isPublicPath(pathname) && !(pathname === "/" && isAuthenticated);
};

/** Prevent duplicate events while allowing each distinct public navigation. */
export const shouldTrackPublicLocation = (
  previousLocation: string | null,
  location: string,
  isAuthenticated: boolean,
): boolean => isPublicRoute(location, isAuthenticated) && previousLocation !== location;
